import { createClient } from "@supabase/supabase-js"

const supabaseUrl = "https://uymxjljgkbocsgfpskxb.supabase.co"
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV5bXhqbGpna2JvY3NnZnBza3hiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ5MzUxMjUsImV4cCI6MjA5MDUxMTEyNX0.QX2iz9MlijZqjyiBe4WmpPTtQtJzu86JDwnOawPoyDI"

export const supabase = createClient(supabaseUrl, supabaseKey)
